import { combineReducers } from 'redux';
import auth from './auth/auth';
import modal from './modal/modal';
import fileControl from './fileControl/fileControl';

const allReducers = combineReducers({
  auth,
  modal,
  fileControl,
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_APP') {
    // eslint-disable-next-line no-param-reassign
    state = undefined;
  }

  return allReducers(state, action);
};

export default rootReducer;
